export function serialize(object: any): string {
    function serialzeRecursivValues(object) {
        const returnableValue = {
            type: typeof object,
            data: null,
        };
        if (object == null || object == undefined) {
            return returnableValue;
        }
        if (object.getMonth) {
            /* only way to detect date objects */
            const dateType = "date" as any;
            returnableValue["type"] = dateType;
            returnableValue["data"] = object.getTime();
        } else if (typeof object == "object") {
            const returnableValueAny = returnableValue as any;
            returnableValueAny["data"] = {};
            for (const key in object) {
                returnableValueAny["data"][key] = serialzeRecursivValues(object[key]);
            }
        } else {
            returnableValue["data"] = object;
        }
        return returnableValue;
    }
    return JSON.stringify(serialzeRecursivValues(object));
}

export function deSerialize(json: string): any {
    const storedValue = JSON.parse(json);
    function deSerializeRecursivValues(literal) {
        const date = new Date();
        const newObject = {};

        switch (literal.type.toLowerCase()) {
            case "number":
                return literal.data != null ? +literal.data : null;
            case "string":
                return literal.data != null ? "" + literal.data : null;
            case "boolean":
                return literal.data != null ? literal.data : null;
            case "date":
                if (literal.data == null) {
                    return null;
                }
                date.setTime(parseInt(literal.data));
                return date;
            case "object":
                if (literal.data == null) return null;
                for (const i in literal.data) {
                    newObject[i] = deSerializeRecursivValues(literal.data[i]);
                }
                return newObject;
            case "undefined":
                return undefined;
            default:
                console.warn(`Can not deserialize type ${literal.type}`);
        }
    }
    const t = deSerializeRecursivValues(storedValue);
    return t;
}
